import { ScreenDevicePage } from '@hq/screen-scan';
import { useNavigate } from 'react-router-dom';
import { hq } from '../session';

/**
 * 我的大屏（GOV 门户）：本机构（含下属机构）已授权的大屏。
 * 监管既然可以授权，就必须能回收：停用/报废的屏可自助吊销（后端限定本机构子树，跨机构范围才含全区屏）。
 */
export default function ScreenDevices() {
  const navigate = useNavigate();

  return (
    <ScreenDevicePage
      hq={hq}
      title="我的大屏"
      canDisable
      onScan={() => navigate('/screen-scan')}
      onOpenScreen={() => window.open('/screen', '_blank')}
      hint="本机构已授权的大屏（含下属机构）。新增大屏请点右上角「申请码确认」，把大屏上显示的 12 位申请码按 4-4-4 三段填入即可；停用的大屏可在此吊销。"
    />
  );
}
